import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[cmOnlyNumbers]',
})
export class OnlyNumbersDirective {
  @Input() type: string;

  constructor() {}

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    if (this.type !== 'number') return;

    const e = <KeyboardEvent>event;
    if (e.key === 'E' || e.key === 'e') {
      e.stopPropagation();
      e.preventDefault();
    }
  }
}
